import { Button, ChevronRight, useStyletron } from "@mezo-org/mezo-clay"

import { SwappableToken } from "#/shared/types"
import { getCurrencySymbol } from "#/shared/utils"
import { TokenIcon } from "#/ui/Token"

type SwapModalTokenSelectorProps = {
  token: SwappableToken
  onClick: () => void
}

export default function SwapModalTokenSelector({
  token,
  onClick,
}: SwapModalTokenSelectorProps) {
  const [, theme] = useStyletron()

  return (
    <Button
      size="large"
      kind="secondary"
      type="button"
      onClick={onClick}
      startEnhancer={() => <TokenIcon token={token} />}
      endEnhancer={() => <ChevronRight color={theme.colors.black} />}
      overrides={{
        BaseButton: { style: () => ({ width: "100%", maxWidth: "160px" }) },
      }}
    >
      {getCurrencySymbol(token)}
    </Button>
  )
}
